<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          珠海漫漫科技有限公司
          <!-- <img src="./assets/img/toplogo.png" alt /> -->
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <!-- <el-menu-item index="/news">新闻资讯</el-menu-item> -->
          <el-menu-item index="/product">产品服务</el-menu-item>
          <el-menu-item index="/goin">公司介绍</el-menu-item>
          <el-menu-item index="/case">人才招聘</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="true">
        <div class="footer-content">
          <p class="footer-company-name">珠海漫漫科技有限公司</p>
          <ul class="content-nav">
            <li>
              <span>地址：珠海市横琴粤澳深度合作区十字门大道338号1栋8楼8076</span>
              <span>电话：0756-6969121</span>
              <span>邮箱：service@aispatial.com</span>
            </li>
            <!-- <li>
              <p>企业介绍</p>
              <span>品牌介绍</span>
              <span>团队介绍</span>
              <span>关于我们</span>
            </li>
            <li>
              <p>服务范围</p>
              <span>产品介绍</span>
              <span>新闻动态</span>
              <span>服务品牌</span>
            </li> -->
          </ul>
          <!-- <img src="./assets/img/ercode.png" alt /> -->
        </div>
        <div class="copyright">
          <span>Copyright © 2020 珠海漫漫科技有限公司 </span>
          <a href="https://beian.miit.gov.cn" target="_blank">
            <span> 粤ICP备18032192号</span>
          </a>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    color: #303133;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  overflow: hidden;
  background-color: #4774b6;
  position: relative;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 50px;
    p {
      text-indent: 56px;
      font-size: 20px;
      color: #fff;
      padding: 10px 0;
    }
    .content-nav {
      display: block;
      list-style-type: disc;
      // margin-block-start: 1em;
      // margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
      li {
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: start;
        align-items: flex-start;
        span {
          color: #fff;
          font-weight: 300;
          padding: 5px 0;
          width: 33.33333%;
          line-height: 1.8;
          font-size: 14px;
          text-align: center;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    border-top: 1px solid #5c84bf;
    height: 30px;
    background: #4774b6;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 14px;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
  .footer-content {
    display: flex;
    flex-direction: column;
  }
  .footer-company-name {
    align-self: center;
  }
}
</style>
